import { render, staticRenderFns } from "./AdminModal.vue?vue&type=template&id=4716e219&"
import script from "./AdminModal.vue?vue&type=script&lang=js&"
export * from "./AdminModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports